export default __webpack_public_path__ + "static/media/Cryptguard.e3cfb6b7.jpg";